import { type PageItem, PageItemType, type PageItemsSettings } from '@/types';

const numericSettingNamesByType: Partial<Record<PageItemType, Set<string>>> = {
  [PageItemType.Booking]: new Set(['timeThreshold', 'forcedTimeThreshold', 'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom']),
  [PageItemType.BookingList]: new Set(['rowCount', 'pageDuration', 'timeThreshold', 'forcedTimeThreshold', 'paddingLeft', 'paddingTop']),
};

function coerceNumericSettingValue(value: unknown) {
  if (typeof value !== 'string') return value;

  const trimmedValue = value.trim();

  if (trimmedValue === '') return value;

  const numericValue = Number(trimmedValue);

  return Number.isFinite(numericValue) ? numericValue : value;
}

export function normalizePageItemSettings(type: PageItemType, settings?: PageItemsSettings | string | null): PageItemsSettings {
  const parsedSettings = typeof settings === 'string' ? JSON.parse(settings) : settings ?? {};
  const numericSettingNames = numericSettingNamesByType[type] ?? new Set<string>();

  return Object.fromEntries(
    Object.entries(parsedSettings).map(([name, value]) => [name, numericSettingNames.has(name) ? coerceNumericSettingValue(value) : value])
  );
}

export function normalizePageItem<T extends Pick<PageItem, 'type' | 'settings'>>(pageItem: T): T {
  return {
    ...pageItem,
    settings: normalizePageItemSettings(pageItem.type, pageItem.settings),
  } as T;
}
